import {useMemo} from 'react'
import {isCheckInCheckOutAvailable} from 'components/Accommodation/Policies/utils'
import {MAXIMUM_POPULAR_FACILITIES} from 'components/Accommodation/PopularFacilities/constants'
import {
  facilityCategories,
  getGroupedFacilities,
  getHotelFacilitiesRanked,
  TOP_FACILITY_IDS
} from 'utils/facilities'

import type {ContentHotel, TranslatedLOVItem} from '@findhotel/sapi'
import type {GroupedFacilities} from 'types/Hotel'

type AccommodationData = {
  isCheckInCheckoutAvailable: boolean
  topFacilities: TranslatedLOVItem[]
  hasPopularFacilitiesMore: boolean
  hasPopularFacilitiesSection: boolean
  groupedFacilities: GroupedFacilities[]
  hasFacilitiesSection: boolean
  hasPolicies: boolean
}

const EMPTY = {
  isCheckInCheckoutAvailable: false,
  topFacilities: [],
  hasPopularFacilitiesMore: false,
  hasPopularFacilitiesSection: false,
  groupedFacilities: [],
  hasFacilitiesSection: false,
  hasPolicies: false
}

export const useAccommodation = (hotel: ContentHotel): AccommodationData => {
  return useMemo(() => {
    if (!hotel) return EMPTY

    const hasCheckInTimeCheckout = isCheckInCheckOutAvailable(hotel)
    const {facilities} = hotel

    const topFacilities = Array.isArray(facilities)
      ? getHotelFacilitiesRanked(
          facilities,
          TOP_FACILITY_IDS,
          MAXIMUM_POPULAR_FACILITIES
        )
      : []

    const groupedFacilities = Array.isArray(facilities)
      ? getGroupedFacilities(facilities, facilityCategories)
      : []

    const hasPolicies =
      Boolean(hotel.checkInSpInst) ||
      Boolean(hotel.checkInMinAge) ||
      Boolean(hotel.deposit) ||
      Boolean(hotel.feesOpt) ||
      Boolean(hotel.checkInInst) ||
      Boolean(hotel.policies) ||
      hasCheckInTimeCheckout

    return {
      isCheckInCheckoutAvailable: hasCheckInTimeCheckout,
      topFacilities,
      hasPopularFacilitiesMore:
        Array.isArray(facilities) &&
        facilities.length > MAXIMUM_POPULAR_FACILITIES,
      hasPopularFacilitiesSection: topFacilities.length > 0,
      groupedFacilities,
      hasFacilitiesSection: groupedFacilities.length > 0,
      hasPolicies
    }
  }, [hotel])
}
